import bus from '@/assets/js/bus';
import { BigNumber as web3BigNumber } from "@ethersproject/bignumber";
import { BigNumber as BigNumberJs } from "bignumber.js";
import Web3 from 'web3';


const UsdtToken_JSON = require("@/assets/abi/UsdtToken.json");
const AldToken_JSON = require("@/assets/abi/AldToken.json");
const AldHome_JSON = require("@/assets/abi/AldHome.json");

let BASE_SCAN_URLS = {
    137: 'https://www.polygonscan.com',
    97: 'https://testnet.bscscan.com',
    11155111: 'https://sepolia.etherscan.io'
};
let BASE_NODES = {
    137: ['https://polygon-rpc.com'],
    97: ["https://bsc-testnet.nodereal.io/v1/d4de3d71347743428d39506a73e92807"],
    11155111: ["https://sepolia.infura.io/v3/a65da3ad7a5c4657ae90ab9cdab5c1ad"]
};

export default {
    install(Vue) {
        Vue.prototype.chainId = 137;
        if(Vue.prototype.chainId == 137){
            const USDT_TOKEN_ADDRESS = "0xc2132D05D31c914a87C6611C10748AEb04B58e8F";// #PRO USDT合约
            const ALD_TOKEN_ADDRESS = "0x1CdAAeA1156fBd628e86ae26e9cAa39e68f2fEf0";// #PRO AldToken合约
            const ALD_Home_ADDRESS = "0xb178461eADD087F01822A1Ef9fA0094054D90c78";// #PRO AldHome合约

            Vue.prototype.UsdtToken_Contract = {abi:UsdtToken_JSON,address:USDT_TOKEN_ADDRESS};
            Vue.prototype.AldToken_Contract = {abi:AldToken_JSON,address:ALD_TOKEN_ADDRESS};
            Vue.prototype.AldHome_Contract = {abi:AldHome_JSON,address:ALD_Home_ADDRESS};

        }else if(Vue.prototype.chainId == 97){
            const USDT_TOKEN_ADDRESS = "0x66D26096897C4fDa935Eb11B82C4d0779BdedcCE";// #TEST TUSDT合约
            const ALD_TOKEN_ADDRESS = "0x08eE437d9d352AFc57562d0377b6Da6F9CB4cAb9";// #TEST ALD合约
            const ALD_Home_ADDRESS = "0xffeAE69E1cf4Fb6f099cDBf8766c034839c27a89";// #TEST DAPP

            Vue.prototype.UsdtToken_Contract = {abi:UsdtToken_JSON,address:USDT_TOKEN_ADDRESS};
            Vue.prototype.AldToken_Contract = {abi:AldToken_JSON,address:ALD_TOKEN_ADDRESS};
            Vue.prototype.AldHome_Contract = {abi:AldHome_JSON,address:ALD_Home_ADDRESS};
        }else if(Vue.prototype.chainId == 11155111){
            const USDT_TOKEN_ADDRESS = "0x2a218d94202b96e2F868f970c4F50837D4F6EdAD";// #SEPOLIA USDT合约
            const ALD_TOKEN_ADDRESS = "0xe8E566341D39076A748f06727cd60C3d514C30ae";// #SEPOLIA ALD合约
            const ALD_Home_ADDRESS = "0xd732Be4fDcea9a99101CD54B7685FAB4368d3a8A";// #SEPOLIA DAPP

            Vue.prototype.UsdtToken_Contract = {abi:UsdtToken_JSON,address:USDT_TOKEN_ADDRESS};
            Vue.prototype.AldToken_Contract = {abi:AldToken_JSON,address:ALD_TOKEN_ADDRESS};
            Vue.prototype.AldHome_Contract = {abi:AldHome_JSON,address:ALD_Home_ADDRESS};
        }
        Vue.prototype.isMainnet = function() {
            return Vue.prototype.chainId == 137;
        }
        Vue.prototype.getChainScan = function(){
            return BASE_SCAN_URLS[Vue.prototype.chainId];
        }

        Vue.prototype.convertToNumberByUnit = function(value,unit){
            return new BigNumberJs(value).multipliedBy(new BigNumberJs(Math.pow(10, unit))).dp(0,BigNumberJs.ROUND_HALF_DOWN).toNumber();
        }
        Vue.prototype.convertToBigNumberByUnit = function(value,unit){
            if (!value) {
                return web3BigNumber.from(0);
            }
            let temp = new BigNumberJs(value).multipliedBy(new BigNumberJs(Math.pow(10, unit))).dp(0,BigNumberJs.ROUND_HALF_DOWN).toFixed();
            let result = web3BigNumber.from(temp);
            return result;
        }
        // Vue.prototype.convertToBigNumberByUnit = function(value, unit) {
        //     return new BigNumberJs(value) .multipliedBy(new BigNumberJs(Math.pow(10, unit)));
        // }
        Vue.prototype.convertFromByUnit = function(value,unit) {
            return new BigNumberJs(value).div(new BigNumberJs(Math.pow(10, unit))).toNumber();
        }
        Vue.prototype.web3Instance = null;
        Vue.prototype.tokenApprove = async (tokenInstance,owner, spender,amount)=> {
            try{
                let params;
                if(Vue.prototype.isMainnet() && Vue.prototype.web3Instance){
                    let gasPrice = await Vue.prototype.web3Instance.eth.getGasPrice();
                    params = {from: owner,gasPrice};
                }else{
                    params = {from: owner};
                }
                let result = await tokenInstance.methods.approve(spender,amount).send(params);
                if(result.status){
                    return true;
                }else{
                    return false;
                }
            }catch (error) {
                console.log(error);
                return false;
            }
        }
        Vue.prototype.contractSend = async (method, from, value) => {
            let params;
            if(Vue.prototype.isMainnet() && Vue.prototype.web3Instance){
                let gasPrice = await Vue.prototype.web3Instance.eth.getGasPrice();
                params = {from: from,value: value, gasPrice: gasPrice};
            }else{
                params = {from: from,value: value};
            }
            return method.send(params);
        }
        Vue.prototype.connectWallet = async function (callback){
            let _this = this;
            if (Vue.prototype.isMobile()) {
                console.log("Automatically reconnect")
                _this.excuteConnect((failInfo) => {
                    console.log(failInfo);
                    setTimeout(function () {
                        _this.connectWallet(callback);
                    }, 1000);
                }, callback);
            } else {
                console.log("Only connect once")
                _this.excuteConnect((failInfo) => {
                    console.log(failInfo);
                }, callback);
            }
        }

        Vue.prototype.excuteConnect = async function (connectFail, callback){
            let _this = this;
            let chainIdHex = "0x" + Vue.prototype.chainId.toString(16);
            if (!window.ethereum) {
                connectFail("window.ethereum is null");
                return false;
            }
            console.log("window.ethereum.chainId:", window.ethereum.chainId);
            let changeChain = true;
            if (changeChain) {
                if (window.ethereum.chainId != chainIdHex) {
                    await window.ethereum.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{chainId: chainIdHex}]
                    }).then(async (res) => {
                        // switch success ，"chainChanged"
                        _this.getWalletAddress(connectFail, callback);
                    }).catch(async (switchError) => {
                        console.log("switch error:", switchError);
                        await window.ethereum.request({
                            method: 'wallet_addEthereumChain',
                            params: [{
                                chainId: chainIdHex,
                                chainName: Vue.prototype.chainId === 137 ? 'Polygon Mainnet' :
                                         Vue.prototype.chainId === 56 ? 'Binance Smart Chain Mainnet' : 
                                         Vue.prototype.chainId === 11155111 ? 'Sepolia Testnet' :
                                         'Binance Smart Chain Testnet',
                                nativeCurrency: {
                                    name: Vue.prototype.chainId === 137 ? 'MATIC' :
                                         Vue.prototype.chainId === 11155111 ? 'ETH' : 'BNB',
                                    symbol: Vue.prototype.chainId === 137 ? 'MATIC' :
                                         Vue.prototype.chainId === 11155111 ? 'ETH' : 'BNB',
                                    decimals: 18
                                },
                                rpcUrls: BASE_NODES[Vue.prototype.chainId],
                                blockExplorerUrls: [BASE_SCAN_URLS[Vue.prototype.chainId]]
                            }]
                        }).then(async (res) => {
                            // add success ，"chainChanged"
                        }).catch((addError) => {
                            console.log("add error:", addError);
                            connectFail(addError);
                        });
                    });
                } else {
                    this.getWalletAddress(connectFail, callback);
                }
            } else {
                if (window.ethereum.chainId != chainIdHex) {
                    connectFail("chainId error")
                    return;
                }
                this.getWalletAddress(connectFail, callback);
            }
        }

        Vue.prototype.getWalletAddress = async function (connectFail, callback){
            const web3Instance = new Web3(window.ethereum);
            Vue.prototype.web3Instance = web3Instance;
            await window.ethereum.request({method: "eth_requestAccounts"}).then(async (res) => {
                // let walletAddress = window.ethereum.selectedAddress;
                let walletAddress = res[0];
                Vue.prototype.walletAddress = walletAddress;
                Vue.prototype.hideConnectWalletBox();
                bus.$emit('showWalletAddress', walletAddress);
                bus.$emit('refreshWalletData');
                if(callback){
                    callback(walletAddress);
                }
            }).catch((err) => {
                connectFail(err);
                return;
            });
        }
    }
}

  